import React from "react";
import MainRouter from "./router/MainRouter";

function App() {
  return <MainRouter />;
}

export default App;
